window.Vlitejs.registerProvider('vimeo', window.VlitejsVimeo);
window.Vlitejs.registerProvider('youtube', window.VlitejsYoutube);



//////////////// FUNCIONES HEADER START //////////
document.querySelectorAll('.collapse-header button.nav-link').forEach(btn => {
    btn.addEventListener('click', () => {
        // Si la pantalla tiene un ancho mayor o igual a 1280px
        if (window.matchMedia('(min-width: 1280px)').matches) {
            document.querySelectorAll('.collapse-subheader').forEach(collapse => {
                // Si el subencabezado no es el correspondiente al botón clickeado y está abierto
                if (btn.nextElementSibling.id !== collapse.id && collapse.classList.contains('show')) {
                    // Cerrar el subencabezado
                    new bootstrap.Collapse(collapse, {
                        toggle: false
                    }).hide();
                }
            });
        }

        // Cambiar el estilo de overflow para la cabecera
        document.querySelector('.collapse-header').style.overflow = 'hidden';
    });
});

document.querySelectorAll('.collapse-header .btn-back').forEach(btn => {
    btn.addEventListener('click', ()=>{
        setTimeout(() => {
            document.querySelector('.collapse-header').style.overflow = 'auto'
        }, 300);
    })
})

// FUNCION SCROLL HEADER
var scrollPos = 0;
const scrollThreshold = 100;
var maxTranslateY = -43; 
var maxTranslateyMov= -100; 
function scrollHeader() {
    var maxScroll = document.querySelector('.c-header').offsetHeight; 
    var translateY = (window.scrollY / maxScroll) * maxTranslateY;
    if(window.matchMedia('(min-width: 769px)').matches) {
        if (window.scrollY > scrollThreshold) {
            document.querySelector('.c-header').classList.add('fix-to-top');
            if (window.scrollY <= maxScroll) {
                var translateY = (window.scrollY / maxScroll) * maxTranslateY;
                document.querySelector('.c-header').style.transform = 'translateY(' + translateY + '%)';
            } else {
                document.querySelector('.c-header').style.transform = 'translateY(' + maxTranslateY + '%)';
            }
        }  else {
            document.querySelector('.c-header').style.transform = 'translateY(0%)';
            document.querySelector('.c-header').classList.remove('fix-to-top');
        }
    } else {
        if (window.scrollY > scrollThreshold) {
            if ((document.body.getBoundingClientRect()).top > scrollPos) {
                document.querySelector('.c-header').style.transform = 'translateY(0%)';
                if(document.querySelector('.c-header').classList.contains('bajando')) {
                    document.querySelector('.c-header').classList.remove('bajando')
                }
            } else {
                if(!document.querySelector('.c-header').classList.contains('bajando')) {
                    document.querySelector('.c-header').classList.add('bajando')
                }
                document.querySelector('.c-header').style.transform = 'translateY(-100%)';
            } 
        }  else {
            document.querySelector('.c-header').style.transform = 'translateY(0%)';
            if(document.querySelector('.c-header').classList.contains('bajando')) {
                document.querySelector('.c-header').classList.remove('bajando')
            }
        }
    }
    scrollPos = (document.body.getBoundingClientRect()).top;
}
       
function reizeCheckHeaderClose() {
    if (window.innerWidth >= 1280) {
        if (document.body.classList.contains('open-menu')) {
            document.body.classList.remove('open-menu');
        }
        if (document.querySelector('.collapse-header').classList.contains('show')) { 
            document.querySelector('.collapse-header').classList.remove('show');
        }
        if (!document.querySelector('.btn-menu-mov').classList.contains('collapsed')) { 
            document.querySelector('.btn-menu-mov').classList.add('collapsed');
        }
    } else {
        if (document.body.classList.contains('open-menu')) {
            document.body.classList.remove('open-menu');
        }
        // console.log(document.querySelector('.collapse-subheader'))
        document.querySelectorAll('.collapse-subheader').forEach(col => {
            if (col.classList.contains('show')) {
                col.classList.remove('show');
            }
        })
       
    }
}

 //////////// FUNCION LISTENERS COLLAPSES HEADER START//////////
 function controlCollapseHeader() {
     const collapseH = document.getElementById('collapseHeader');
     collapseH.addEventListener('show.bs.collapse', function () {
         document.body.classList.add('open-menu');
     });
     collapseH.addEventListener('hidden.bs.collapse', function () {
         if ( window.matchMedia('(min-width: 1280px)').matches) { 
             setTimeout(() => {
                 const allClosed = Array.from(document.querySelectorAll('.collapse-subheader')).every(collapse => !collapse.classList.contains('show'));
                 if (allClosed) {
                     document.body.classList.remove('open-menu');
                 }
             }, 100);
    
         } else {
             if (document.querySelector('.btn-menu-mov').classList.contains('collapsed')){
                 document.querySelectorAll('.collapse-subheader').forEach(collapse => {
                     if (collapse.classList.contains('show')) {
                         new bootstrap.Collapse(collapse, {
                             toggle: false
                         }).hide();
                     }
                 })
                 document.body.classList.remove('open-menu');
                 document.body.classList.remove('open-submenu');
             } 
         }
     });
 }
  //////////// FUNCION LISTENERS COLLAPSES HEADER END//////////

//////////////// FUNCIONES HEADER END //////////

//////////////// FUNCION FOOTER COLLAPSES START //////////
function resizeFooter() {
    const collapseElement = document.querySelectorAll('footer .collapse');
    const toggleButton = document.querySelectorAll('footer .btn-drop');
    const screenWidth = window.innerWidth;
    collapseElement.forEach(collapse =>{
        const collapseInstance = new bootstrap.Collapse(collapse, {
            toggle: false
        })
        if (screenWidth >= 900) {
            collapseInstance.show();
        } else {
            collapseInstance.hide();
        }
    })
    toggleButton.forEach(btn =>{
        if (screenWidth >= 900) { 
            btn.disabled = true;
        } else {
            btn.disabled = false;
        }
    })
}
//////////////// FUNCION FOOTER COLLAPSES END //////////

//////////////// FUNCION INICAR VIDEOS  START //////////
function inicializarVideos() {
    document.querySelectorAll('.video-js-only .video').forEach(video => {
        let provider = null;
        let poster = null;
        if(video.dataset.poster) {
            poster = video.dataset.poster
        }
        let options = {
            controls: true,
            volume: true,
            fullscreen: true,
            loop: false,
            muted: false,
            playPause: true,
            progressBar: true,
            time: true,
            bigPlay: true,
            poster: poster
        };
     

        if(video.dataset.youtubeId) {
            provider = "youtube";
        } else if(video.dataset.vimeoId) {
            provider = "vimeo";
        }

        let vliteConfig = {
            options: options,
        };

        if (provider) {
            vliteConfig.provider = provider;
        }
       const pVideo =  new window.Vlitejs(video, vliteConfig)

    })
}
//////////////// FUNCION INICAR VIDEOS  END //////////

//////////////// FUNCION STOP VIDEO  START //////////

function stopVideoSmart() {
    document.getElementById('videoModal').addEventListener('click', (event) => {
        // Si el clic es sobre el fondo del modal o el botón de cerrar, detén el video
        if (event.target.classList.contains('btn-close') || event.target.classList.contains('modal')) {
            document.getElementById('videoSmart').currentTime = 0;
            document.getElementById('videoSmart').pause();
        }
    });
}
//////////////// FUNCION STOP VIDEO END //////////

//////////////// FUNCION MARCAR SCROLL LIST SITCKY START //////////

function marcarHrefScoll() {
    const sections = document.querySelectorAll(".js-link-slide");
    const navLinks = document.querySelectorAll(".swiper-uranolab a");

    const swiperElement = document.querySelector(".swiper-uranolab");
    const thresholdValue = swiperElement && swiperElement.parentElement.id === "analysis-spy" ? 0.15 : 0.8;

    // IntersectionObserver para detectar cuándo las secciones entran en la vista
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const id = entry.target.getAttribute("id");
            const link = document.querySelector(`a[href="#${id}"]`);
    
            if (entry.isIntersecting) {
                navLinks.forEach(link => link.parentElement.classList.remove("active"));
                link.parentElement.classList.add("active");
            }
        });
    }, { threshold: thresholdValue });  // threshold controla cuándo se considera que una sección está visible
    
    sections.forEach(section => {
        observer.observe(section);
    });
    
    // Manejar clics en los enlaces para resaltar el enlace correspondiente
    navLinks.forEach(link => {
        link.addEventListener("click", function (event) {
            event.preventDefault();
    
            navLinks.forEach(link => link.parentElement.classList.remove("active"));
            link.parentElement.classList.add("active");
    
            const href = this.getAttribute("href").substring(1);
            let offsetTop = document.getElementById(href).offsetTop - 60;
           
            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        });
    });
}

//////////////// FUNCION MARCAR SCROLL LIST SITCKY END //////////

//////////////// FUNCION AJUSTAR IMAGEN SCROLL FIXED PRODUCT  START //////////

function verificarAlturaYScroll() {
    window.addEventListener("scroll", ()=> {
        if (document.querySelector('.fixed-product .fixed-product_img').offsetHeight > window.innerHeight) {
            document.querySelector('.fixed-product .fixed-product_img').classList.add('small-img')
        } 
    })
}

//////////////// FUNCION AJUSTAR IMAGEN SCROLL FIXED PRODUCT  END //////////

//////////////// FUNCION INICIALIZACION SWIPERS START //////////
let cSwipers = [];
function initializeSwiper() {
    document.querySelectorAll('.swiper').forEach((swiper, index) => {
        if (swiper.dataset.plugins) {
            let swiperConfig = {};
            
            if (window.matchMedia('(max-width: 740px)').matches) {
                swiperConfig.spaceBetween = 20;
            }
            
            // Configura plugins adicionales según el dataset
            if (swiper.dataset.plugins) {
                // if (swiper.dataset.plugins.includes('pagination')) {
                //     swiperConfig.pagination = {
                //         el: ".swiper-pagination",
                //         type: "fraction",
                //     };
                // }
                if (swiper.dataset.plugins.includes('paginationDinamic')) {
                    swiperConfig.pagination = {
                        el: ".swiper-pagination",
                        dynamicBullets: true,
                    };
                }
                if (swiper.dataset.plugins.includes('navigation')) {
                    swiperConfig.navigation = {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    };
                }
                if (swiper.dataset.plugins.includes("grabCursor")) {
                    swiperConfig.grabCursor = true;
                }
                if (swiper.dataset.plugins.includes("slidesPerView")) {
                    swiperConfig.slidesPerView = "auto";
                }
                if (swiper.dataset.plugins.includes("spaceBetween")) {
                    swiperConfig.spaceBetween = 24;
                }
                if (swiper.dataset.plugins.includes("freeMode")) {
                    swiperConfig.freeMode = { enabled: true };
                }
                if (swiper.dataset.plugins.includes("scrollbar")) {
                    swiperConfig.scrollbar = {
                        el: swiper.querySelector('.swiper-scrollbar'),
                        draggable: true,
                    };
                }

                if (swiper.dataset.plugins.includes("tablet")) {
                    if(swiper.dataset.plugins.includes('980')) {
                        if (window.matchMedia("(max-width: 980px)").matches) {
                            cSwipers[index] = new Swiper(swiper, swiperConfig);
                        } else {
                           cSwipers[index] = null;
                        }
                    } else {
                        if (window.matchMedia("(max-width: 979.98px)").matches) {
                            cSwipers[index] = new Swiper(swiper, swiperConfig);
                        } else {
                           cSwipers[index] = null;
                        }
                    }
                } else if(swiper.dataset.plugins.includes("movil")){
                    if (window.matchMedia("(max-width: 768px)").matches) {
                        cSwipers[index] = new Swiper(swiper, swiperConfig);
                    } else {
                       cSwipers[index] = null;
                    }
                } else {
                    cSwipers[index] = new Swiper(swiper, swiperConfig);

                }
            }
        }
    });
}

// Función para destruir todas las instancias de Swiper
function destroySwiper() {
    cSwipers.forEach((swiperInstance, index) => {
        if (swiperInstance) {
            swiperInstance.destroy(true, true);
            cSwipers[index] = null; // Limpia la instancia en el array
        }
    });
}

// Verifica el tamaño de la pantalla e inicializa/destruye Swiper
function checkAndInitializeSwiper() {
    destroySwiper();
    initializeSwiper();
}


//////////////// FUNCION INICIALIZACION SWIPERS END //////////

//////////////// FUNCION INICIALIZACION SWIPER CON VIDEO START //////////
function initializeSwiperVideo(elements) {
    if(elements) {
        elements.forEach(element => {
            const videos = element.querySelectorAll(".vlite-video");
            let swiper;
            let autoSlideTimeout;
            let poster = null;
            let videoInstance = [];
        
            function clearAutoSlideTimeout() {
                if (autoSlideTimeout) {
                    clearTimeout(autoSlideTimeout);
                    autoSlideTimeout = null;
                }
            }
        
            // Inicializa cada video con vlite.js
            videos.forEach((video) => {
                let options = {
                    controls: false,
                    volume: false,
                    fullscreen: true,
                    loop: false,
                    muted: true,
                    playPause: false,
                    progressBar: false,
                    time: false,
                    bigPlay: false,
                    autoplay: false,
                };
                let provider = null;
        
                if (video.classList.contains("vimeo")) {
                    provider = "vimeo";
                }
                if (video.classList.contains("youtube")) {
                    provider = "youtube";
                }
                if (video.dataset.poster) {
                    poster = video.dataset.poster;
                }
        
                let vliteConfig = { options };
                if (provider) {
                    vliteConfig.provider = provider;
                }
                if (poster) {
                    vliteConfig.poster = poster;
                }
        
                let vid = new Vlitejs(video, vliteConfig);
                vid.onReady = function (player) {
                    videoInstance.forEach((vI, key) => {
                        if (vI.id === player.media.id) {
                            videoInstance[key].player = player;
                        }
                    });
                };
        
                videoInstance.push({ id: video.id, video: vid, player: null });
            });
        
            // Inicializa Swiper
            swiper = new Swiper(element, {
                loop: true,
                speed: 500,
                effect: "creative",
                simulateTouch: false,
                creativeEffect: {
                    prev: {
                        shadow: true,
                        translate: [0, 0, -1],
                    },
                    next: {
                        translate: ["100%", 0, 0],
                    },
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction",
                },
                on: {
                    init: function () {
                        // console.log("Swiper initialized");
                        // handleAutoSlide(this.slides[this.activeIndex], videoInstance);
                    },
                    activeIndexChange: function () {
                        clearAutoSlideTimeout();
                        const prevSlide = this.slides[this.previousIndex];
                        const activeSlide = this.slides[this.activeIndex];
        
                        // Mostrar la tarjeta activa
                        if (prevSlide) {
                            prevSlide.querySelector(".card").classList.remove("show");
                        }
                        if (activeSlide) {
                            activeSlide.querySelector(".card").classList.add("show");
                        }
        
                        // Pausa el video del slide anterior
                        if (this.activeIndex > 0) {
                            const prevVideoIndex = this.activeIndex - 1;
                            const prevVideoData = videoInstance[prevVideoIndex];
                            if (prevVideoData && prevVideoData.player) {
                                prevVideoData.player.pause();
                            }
                        }
                    },
                },
            });
        })

    }

    function handleAutoSlide(activeSlide, videos) {
        clearAutoSlideTimeout();
        const videoData = videos[activeSlide.dataset.video];
        if (videoData) {
            setTimeout(() => {
                if (videoData.player) {
                    videoData.player.off("ended");
                    videoData.player.on("ended", () => {
                        swiper.slideNext();
                    });
                    videoData.player.play();
                }
            }, 1000);
        } else {
            autoSlideTimeout = setTimeout(() => {
                swiper.slideNext();
            }, 6000);
        }
    }
}
//////////////// FUNCION INICIALIZACION SWIPER CON VIDEO END //////////

//////////////// FUNCION SCROLL LINK START //////////
function updateSelectBasedOnScroll() {
    window.addEventListener("scroll", ()=> {
        let currentSection = null;
    
        // Recorre cada sección y detecta cuál está actualmente visible
        $('.js-link-slide').each(function () {
            const sectionTop = $(this).offset().top; // Parte superior de la sección
            const sectionHeight = $(this).outerHeight(); // Altura de la sección
            const scrollTop = $(window).scrollTop(); // Posición actual del scroll
            if (scrollTop >= sectionTop - 200 && scrollTop < sectionTop + sectionHeight) {
                currentSection = `#${$(this).attr('id')}`; // Guarda el ID de la sección visible
            }
        });
    
        if (currentSection) {
            // Actualiza el valor del select sin disparar el evento change
            $('.select2-sticky').val(currentSection).trigger('change.select2');
        }
    })
}

// Maneja el evento change del select para desplazarse a la sección
$('.select2-sticky').on('change', function () {
    const target = $(this).val(); // Obtén el valor del option seleccionado (el href)
    if (target) {
        // Desplazamiento suave a la sección correspondiente
        $('html, body').animate({
            scrollTop: $(target).offset().top
        }, 0); 
    }
});


//////////////// FUNCION SCROLL LINK END //////////

function initApp() {
    $('.select2-sticky').select2();

    bindEvents();
    resizeFooter();
    inicializarVideos();
    controlCollapseHeader()
    reizeCheckHeaderClose();
    if(document.querySelector('.fixed-product')) { 
        verificarAlturaYScroll();
    }
    checkAndInitializeSwiper();
    var filterCollapse = document.getElementById('filters-collapse');
    if (filterCollapse) {
        filterCollapse.addEventListener('shown.bs.collapse', function () {
            cSwipers.forEach(function (s) { if (s) s.update(); });
        });
    }
    initFiltersSticky();
    initializeSwiperVideo(document.querySelectorAll(".swiper-home"));
    if(document.querySelector('.c-list-sticky')) { 
        updateSelectBasedOnScroll();
    }
    marcarHrefScoll();
    // if( document.querySelector('.c-fixed-item') ||  document.querySelector('.c-list-sticky')) {
    //     controlScrollUp();
    // }
}

function handleResize() {
    resizeFooter();
    checkAndInitializeSwiper();
    // controlScrollUp();
    closeFiltersOnMobile();
}

function initFiltersSticky() {
    const filters = document.querySelector('.c-filters');
    if (!filters) return;
    const mq = window.matchMedia('(max-width: 979.98px)');
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'height:1px;margin-bottom:-1px;';
    filters.before(sentinel);
    const observer = new IntersectionObserver(([entry]) => {
        filters.classList.toggle('is-sticky', !entry.isIntersecting && mq.matches);
    });
    observer.observe(sentinel);
    mq.addEventListener('change', () => {
        if (!mq.matches) filters.classList.remove('is-sticky');
    });
}

function closeFiltersOnMobile() {
    const filtersCollapse = document.getElementById('filters-collapse');
    if (!filtersCollapse) return;
    if (window.matchMedia('(max-width: 979.98px)').matches && filtersCollapse.classList.contains('show')) {
        bootstrap.Collapse.getOrCreateInstance(filtersCollapse).hide();
    }
}
function updateFiltersStickyTop() {
    const filters = document.querySelector('.c-filters');
    if (!filters) return;
    const belowSm = window.matchMedia('(max-width: 767.98px)').matches;
    if (!belowSm) {
        filters.classList.remove('up');
        return;
    }
    const isSticky = filters.classList.contains('is-sticky');
    const headerVisible = !document.querySelector('.c-header').classList.contains('bajando');
    filters.classList.toggle('up', isSticky && headerVisible);
}

function handleScroll() {
    scrollHeader();
    reizeCheckHeaderClose();
    updateFiltersStickyTop();
}


function handleClick(event) {
    switch (true) {
        case event.target.matches(".backdrop"):
            document.querySelectorAll('.collapse-header').forEach(collapseH => {
                if (collapseH.classList.contains('show')) {
                    const collapseHInstance = bootstrap.Collapse.getInstance(collapseH);
                    collapseHInstance.hide();
                }
            });
        
            document.querySelectorAll('.collapse-subheader').forEach(collapse => {
                if (collapse.classList.contains('show')) {
                    const collapseInstance = bootstrap.Collapse.getInstance(collapse);
                    collapseInstance.hide();
                }
            });
            break;

        case !!event.target.closest(".btn-show"):
            event.target.closest('.btn-show').closest('.c-fixed-item').classList.toggle('show-hide');
            break;

        case event.target.matches(".btn-toggle-list"):
            document.querySelector('.lista-distribuidores').classList.toggle('hide');
            document.querySelector('.btn-toggle-list').classList.toggle('rotate');
            break;

        case event.target.matches("#btnModalVideo"):
            document.getElementById('videoSmart').play();
            stopVideoSmart();
            break;

        case event.target.matches("#videoModal"):
        case event.target.matches(".btn-close"):
            document.getElementById('videoSmart').currentTime = 0;
            document.getElementById('videoSmart').pause();
            break;
        
        default:
            break;
    }

}

function bindEvents() {
    // window.addEventListener("load", handleLoad);
    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);
    document.querySelector(".mainuranovet").addEventListener("click", handleClick);
}

document.addEventListener("DOMContentLoaded", initApp);
